module.exports = __webpack_public_path__ + "media/images/signature-69b235e3acebc357cf29ae02142a81489b2533e7188001f08cc165935de64dee.png";